var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"outlined":"","hide-details":"","label":_vm.cartText,"items":_vm.quantityOptions,"no-data-text":_vm.$t('errors.fullyBooked')},model:{value:(_vm.currentlySelectedQuantity),callback:function ($$v) {_vm.currentlySelectedQuantity=$$v},expression:"currentlySelectedQuantity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }